
import { createSlice } from "@reduxjs/toolkit";
import { getQuote } from "../reduxApi/quoteReduxApi";

const quoteSlice = createSlice({
    name: 'quote',
    initialState: {
        status: 'idel',
        isFiltered: false,
        quote: [],
    },
    reducers: {
         setFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteQuoteAction: (state, action) => {
            action.payload.forEach((ROWID) => {
                const index = state.quote.findIndex((item) => item.ROWID === ROWID);
                if (index !== -1) {
                    state.quote.splice(index, 1);
                }
            });
        },
        updateQuoteAction: (state, action) => {
            // console.log("action", action.payload.ROWID)
            const index = state.quote.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.quote.splice(index, 1, action.payload)
    
            }
        },
        addQuoteAction: (state, action) => {
            console.log("Adding Quote:", action.payload);
            const temp = action.payload;
            temp.ROWID = action.payload.ROWID;
            // state.quote.unshift({quote: temp});  
             if (!Array.isArray(state.quote)) {
            console.warn("State quote was not an array. Resetting to an empty array.");
            state.quote = [];
          }
          state.quote.unshift(temp); 
      
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getQuote.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getQuote.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing Quote Data", action.payload)
                // state.quote = action.payload.data.response;
                state.quote = Array.isArray(action.payload.data.response) ? action.payload.data.response : [];

            })
    }
})
export const { deleteQuoteAction, updateQuoteAction, addQuoteAction,setFilteredStatus } = quoteSlice.actions
export default quoteSlice.reducer